// extracted by mini-css-extract-plugin
export default {"light":"inHFz5","dark":"DWioAG","icon":"xqvK9r"};